var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAuthenticationB = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22z", fill: fills.light }),
        React.createElement("path", { d: "M10.884 29.523a7.769 7.769 0 01-2.284-5.45v-.105a7.752 7.752 0 012.375-5.482A7.734 7.734 0 0116.52 16.3a7.752 7.752 0 017.478 6.143H38.085a1.535 1.535 0 010 3.068h-2.046v3.287c0 .847-.687 1.534-1.534 1.534h-4.9a1.534 1.534 0 01-1.533-1.534v-3.287h-4.045c-.695 3.561-3.825 6.268-7.59 6.295a7.757 7.757 0 01-5.553-2.284zm8.095-8.035a3.667 3.667 0 00-6.253 2.527v.036a3.665 3.665 0 003.684 3.635 3.638 3.638 0 002.582-1.09 3.641 3.641 0 001.055-2.547v-.034a3.645 3.645 0 00-1.068-2.527z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
